import { render, staticRenderFns } from "./FileView.vue?vue&type=template&id=4d7a077c&scoped=true&"
import script from "./FileView.vue?vue&type=script&lang=js&"
export * from "./FileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7a077c",
  null
  
)

export default component.exports